import client from "./client";

export default {
    async getPropertyCategories(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/property-categories', filters)));
    },

    async createPropertyCategories(data) {
        return client.parseResponse(await client.post('/property-categories', data))
    },

    async getPropertyCategory(id) {
        return client.parseResponse(await client.get('/property-categories/' + id));
    },

    async editPropertyCategory(data) {
        return client.parseResponse(await client.put('/property-categories/' + data.id, data))
    },

    async deletePropertyCategory(data) {
        return client.parseResponse(await client.delete('/property-categories/' + data.id, data))
    }
}
